import { c } from 'ttag';

/** Portal footer. Legal link hrefs are placeholders to wire to real URLs, all in the list below. */
const LEGAL_LINKS = (): { label: string; href: string }[] => [
    { label: c('Footer').t`Terms of use`, href: '#' },
    { label: c('Footer').t`Legal notice`, href: '#' },
    { label: c('Footer').t`Privacy policy`, href: '#' },
    { label: c('Footer').t`Cookies`, href: '#' },
];

const Footer = () => (
    <footer className="mt-auto flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-border-norm px-6 py-4 text-xs text-text-500">
        <nav aria-label={c('Footer').t`Legal information`} className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {LEGAL_LINKS().map((link) => (
                <a key={link.label} href={link.href} className="link link-weak">
                    {link.label}
                </a>
            ))}
        </nav>
        <span className="ml-auto">© {new Date().getFullYear()} Freelance.com</span>
    </footer>
);

export default Footer;
